import '@usb-shield/react-link/dist/library/styles/index.css'
import { USBColumn, USBGrid } from '@usb-shield/react-grid'
import { defaultGridOptions } from '@/utils/usb-grid.util'
import { useMediaQuery } from '@/utils/usb-media-query.util'
import styles from '@/modules/products/ProductDocumentPage/DisplayViews/displayViews.module.scss'
import '@usb-shield/react-grid/dist/library/styles/index.css'
import { useRouter } from 'next/router'
import Breadcrumb, { GetBreadcrumbs } from '@/components/Breadcrumb/Breadcrumb'
import USBDropdown from '@usb-shield/react-dropdown'
import { useEffect, useRef, useState } from 'react'
import dynamic from 'next/dynamic'
import ProductHeroButtonWrapper from '@/modules/products/components/ProductHeroButtonWrapper/ProductHeroButtonWrapper'
import USBNotification from '@usb-shield/react-notification'
import { buildNestedStructure } from '@/utils/build-nested-list/build-nested-elements.util'
import SideNavMenu from '@/modules/products/ProductDocumentPage/components/SideNavMenu/SideNavMenu'
import { sandboxDropdownChangeCb } from '@/modules/products/ProductDocumentPage/utils/callbacks'
import GlobalSideNavMenu from '@/modules/products/ProductDocumentPage/components/SideNavMenu/GlobalSideNavMenu'
import TableOfContent from '@/modules/products/ProductDocumentPage/components/TableOfContent/TableOfContent'
import { useCookies } from 'react-cookie'
import { getElavonNonUSBreadcrumbs, buildTocMenu, getCustomBreadcrumbs } from '@/modules/products/ProductDocumentPage/utils/productDocumentPage.utils'
import translation from '@/src/i18n'
import { useTranslation } from 'react-i18next';
import { getCookie } from 'cookies-next';
import ProductSections from '../components/ProductSections/ProductSections'
import { PageData } from '@/modules/products/ProductDocumentPage/DisplayViews/displayViews.model';
import { TocItem } from '../components/ProductSections/productSections.model';
import { GlobalSideNavDataProcessor } from '../components/SideNavMenu/GlobalSideNavDataProcessor'
import { convertedDocumentLink } from '@/modules/products/ProductDocumentPage/utils/documentLinkConversion.utils';

const ReactMarkDown = dynamic(
  () => import('@/components/ReactMarkDown/ReactMarkDown'),
  {
    ssr: false,
  }
)

const threeColsOption = {
  span: null,
  spans: {
    xlarge: 3,
    large: 3,
    medium: 3,
    small: 3,
  },
  offset: {
    xlarge: 0,
    large: 0,
    medium: 0,
    small: 0,
  },
  padding: 'zero',
  align: 'start',
  justify: 'stretch',
}

const tenColsOption = {
  span: null,
  spans: {
    xlarge: 10,
    large: 10,
    medium: 8,
    small: 4,
  },
  offset: {
    xlarge: 0,
    large: 0,
    medium: 0,
    small: 0,
  },
  display: 'flex',
  padding: 'normal',
  align: 'start',
  justify: 'start',
}
let selectedDropDownValue = '',
  toc: any,
  router: any

const handleClick = (e: any, selectedTocTile: string) => {
  e.preventDefault()
  let x = document.getElementsByClassName(styles.selectedTocTitle)
  // Remove selected styles for previous target
  if (x.length > 0) {
    x[0].parentElement?.removeAttribute('style')
    x[0].removeAttribute('style')
    x[0]?.classList.remove(styles.selectedTocTitle)
  }
  const eleId = convertedDocumentLink(selectedTocTile)
    // .replace(/[&\/\\#,;+()$~%.'":*?<>{}]/g, '')
    // .replace('®-–', '-')
  const ele: any = document.getElementById(eleId)
  const selectedValue = toc.find(
    (res: any) => res.value === ele?.children[0]?.textContent
  )
  selectedDropDownValue =
    selectedValue && selectedValue.value && selectedValue.value.length
      ? selectedValue.value
      : ''
  ele?.children[0]?.classList.add(styles.selectedTocTitle)
  if (x.length == 0) {
    e?.target?.classList.add(styles.selectedTocTitle)
  }
  selectedTocTile = selectedTocTile.replace('_toc', '')
  const id = convertedDocumentLink(selectedTocTile)
    // .replace(/[&\/\\#,;+()$~%.'":*?<>{}]/g, '')
    // .replace('®-–', '-')

  if (router) {
    router.push('#' + id)
  }
}

/**
 * Renders the appropriate component based on the presence of `genericSection` or `documentationSectionsCFM` in `pageData`.
 * @param pageData - The page data object to check.
 * @returns JSX.Element
 */
export function renderPageContent(pageData: PageData, handleExtractToc:(extractedToc: TocItem[]) => void): JSX.Element | null {

  if (pageData.genericSection) {
    return (
      <ReactMarkDown
        content={pageData.genericSection.body}
        router={router} // Pass router if needed
      />
    );
  }

  if (pageData.documentationSectionsCFM) {
    return <ProductSections pageData={pageData} onExtractToc={handleExtractToc}/>;
  }

  return null;
}

/**
 * Maps SectionsToc to an array of objects with the structure { children: [], depth: 2, value: heading }.
 * @param sectionsToc - The array of TOC items to map.
 * @returns An array of mapped TOC objects.
 */
export function mapSectionsTocToTocItems(sectionsToc: TocItem[]): { children: []; depth: number; value: string }[] {
  return sectionsToc.map((tocItem) => ({
    children: [] as [], // Explicitly set children to an empty tuple
    depth: 2, // Assuming depth is always 2 for this mapping
    value: tocItem.heading, // Use the heading as the value
    id: convertedDocumentLink(tocItem.heading)
    // .replace(/[&\/\\#,;+()$~%.'":*?<>{}]/g, '')
    // .replace(/\s+/g, '-')
    // .toLowerCase(),
  }))
  .filter((item) => item.value.trim() !== ''); // Filter out items with empty values
}

const ThreeColLayout = ({
  pageData,
  sideNavData,
  componentToc,
  displayVersions,
  prodDocPageSideNavData
}: {
  pageData: any
  sideNavData: any
  componentToc: any
  displayVersions: any
  prodDocPageSideNavData?: any
}) => {

  const [navWrapperStyles, setNavWrapperStyles] = useState<{ top: string; bottom: string }>({
    top: '0px',
    bottom: '0px',
  });
  let locale = getCookie('locale') ?? process.env.DEFAULT_LOCALE
  const lang = locale?.substring(0, 2)
  const { t } = useTranslation();

  const [dynamicHeight, setDynamicHeight] = useState<number>(0)
  const tocWrapperRef = useRef<HTMLDivElement | null>(null)
  const footerRef = useRef<HTMLElement | null>(null)
  
  const [sectionsToc, setSectionsToc] = useState<TocItem[]>([]);

  function handleExtractToc(extractedToc: TocItem[]): void {
    setSectionsToc(extractedToc);
  }
  const mappedTocItems = mapSectionsTocToTocItems(sectionsToc);

  const sideNavExclusionPages: any[] = ['solution-areas', 'product-suites', 'support', 'contact', 'dashboard'];

  let tocExists = false
  // updates to allow for unit testing component.  the toc needs to be available for functions like handleClick()
  toc = componentToc

  // for Sections page, map sectionsToc to format needed for generic section 
  if (pageData?.documentationSectionsCFM) {
    toc = mappedTocItems
  }
  
  // check if TOC exists for Generic markdown page
  if (toc != undefined && toc[0]?.value != '' && toc[0]?.value != undefined) tocExists = true

  
  const [showSuccessMessage, setShowSuccessMessage] = useState<boolean>(false)
  const [isScrolled, setIsScrolled] = useState(true)
  const [height, setHeight] = useState(0)


  const pageTitle = process.env.SITE_BRAND === 'elavon'
    ? pageData?.genericSection?.heading
    : pageData?.metaData?.pageTitle;

  const [activeAnchorId, setActiveAnchorId] = useState('')

  router = useRouter()
  let hashValFromUrl

  if (router) {
    const pageUrl = router.asPath
    hashValFromUrl = pageUrl.split('#')[1]
  }

  const productDetails = {
    productName: pageData?.metaData?.name,
    productVersion: router.asPath.split('/')[3],
    productId: pageData?.metaData?.id,
  }

  hashValFromUrl ??= '' // Ensure hashValFromUrl is defined

  const usbDropdownRef = useRef()

  let breadcrumbItems: any
  const segments = router.asPath.replace(/^\/+/, '').split('/')

  const [cookiesVal] = useCookies(['locale']);
  const localeVal = cookiesVal.locale ?? process.env.DEFAULT_LOCALE
  const featureDocumentationSidenav: string = process.env.FEATURE_DOCUMENTATION_SIDENAV || 'false'

  // Check if the device is mobile or tablet
  let isMobileDevice = useMediaQuery('(min-width: 250px) and (max-width: 1056px)');

  let sideNavLinks

  // get sidenav links based on brand
  // Need to remove the localVal check once the US Bank side nav is ready for french canada locale.
  // For now, we are only rendering the side nav for en-us locale
  if (process.env.SITE_BRAND !== 'usbank') {
    sideNavLinks = buildNestedStructure(sideNavData) 
  } else {
    sideNavLinks = ((!sideNavExclusionPages.includes(segments[0]) || !sideNavExclusionPages.includes(segments[1])) && (featureDocumentationSidenav === 'true' && localeVal == 'en-us'))
      ? GlobalSideNavDataProcessor(prodDocPageSideNavData, sideNavData, segments)
      : buildNestedStructure(sideNavData)
  }

  let removeIndexValue: any;
  if(router.asPath.split('/').includes('products') === true && localeVal == 'en-us') {
    removeIndexValue = [4]
  } else if(router.asPath.split('/').includes('products') === true && localeVal != 'en-us') {
    removeIndexValue = [3,5]
  } else {
    removeIndexValue = [4]
  }
  if (process.env.SITE_BRAND === 'elavon') {

    const [cookies] = useCookies(['countryCode'])
    const countryCode = (cookies.countryCode || 'US')

    if (router.asPath.split('/').includes('products') === false) {
      breadcrumbItems = [
        ...GetBreadcrumbs([], false, 0, 0).map((item) => ({
          ...item,
          text: item.text.charAt(0).toUpperCase() + item.text.slice(1) || '',
        })),
      ]
    } else {
      breadcrumbItems = getElavonNonUSBreadcrumbs(countryCode, pageData?.genericSection?.heading, router.asPath.split('/'))
    }
  } else {
    breadcrumbItems = getCustomBreadcrumbs(pageData, segments)
  }

  const pageTitleMetadata: any = pageData?.metaData?.pageTitles  

  const promoteSuccessHandler = () => {
    setShowSuccessMessage(true)
  }

  const handleDropdownChange = (event: any) => {
    sandboxDropdownChangeCb(event, localeVal);
  };

  // Update documentation header design for Tablet/Mobile view

  let documentHeader = styles.headerSectionSandboxEnabled
  let headerSectionMobile: any = ''
  let defaultTocValue: any = ''

  const productNameTitle = process.env.SITE_BRAND == 'usbank' ? 'API Product Documents' : pageData?.metaData?.name
  
  const sideNavGroupStyle = process.env.SITE_BRAND == 'usbank' ? styles.sideNavGroupStyle : styles.productNameTitle

  if (process.env.FEATURE_SANDBOX_PROJECTS === 'false') {
    documentHeader = styles.headerSection
    headerSectionMobile = (
      <div className={styles.headerSectionMobile}>
        <USBGrid
          gridGap={defaultGridOptions.gridGap}
          alignItems={defaultGridOptions.alignItems}
          columnCount={defaultGridOptions.columnCount}
          justifyContent={defaultGridOptions.justifyContent}
          display={defaultGridOptions.display}
          padding={defaultGridOptions.padding}
        >
          <USBColumn
            layoutOpts={tenColsOption}
            addClasses={styles.headerSectionLayout}
          >
            {process.env.SITE_BRAND === 'elavon' ? (
              <Breadcrumb
                items={breadcrumbItems}
                updateLayoutOpt={true}
              ></Breadcrumb>
            ) : (
              <Breadcrumb
                pageTitleMetadata={pageTitleMetadata}
                removeMenuFlag={true}
                removeMenuIndex={removeIndexValue}
                updateLayoutOpt={true}
                productVersionNumber={true}
              />
            )}
            <h1 className={styles.docTitle}>{pageTitle}</h1>
          </USBColumn>
        </USBGrid>
      </div>
    )
    if (toc?.length > 0) {
      defaultTocValue = toc[0].value
    }
  }

  let leftSideNavStyle: string = `${styles.leftSideViewDocuments}`

  //calculate leftSidebar width dynamically so sidebar stays within width of grid column
  const navWrapperRef = useRef<HTMLDivElement | null>(null);
  const [ parentWidth, setParentWidth ] = useState<any>(0);

  useEffect(() => {
    let parentWidth: number = 0;
    if (navWrapperRef.current?.parentElement) {
      parentWidth = navWrapperRef.current.parentElement.offsetWidth;
      parentWidth = parentWidth + (process.env.SITE_BRAND === 'elavon' ? 0 : 32); // Add padding
      setParentWidth(parentWidth);
    }

  }, [navWrapperRef.current?.parentElement?.offsetWidth]);

  useEffect(() => {
    const updateNavWrapperStyles = (): void => {
      // Select header and footer elements by their class names or IDs
      const headerElement = document.querySelector('header'); // Replace with the actual class or ID of the header
      const footerElement = document.querySelector('footer'); // Replace with the actual class or ID of the footer

      const headerHeight = headerElement?.clientHeight || 0;
      const footerHeight = footerElement?.clientHeight || 0;

      setNavWrapperStyles({
        top: `${headerHeight + 16}px`,
        bottom: `${footerHeight + 16}px`,
      });
    };

    // Update styles on mount and on window resize
    updateNavWrapperStyles();
    window.addEventListener('resize', updateNavWrapperStyles);

    return () => {
      window.removeEventListener('resize', updateNavWrapperStyles);
    };
  }, []);

  useEffect(() => {
    const scrollToAnchor = (): void => {
      const hash = router.asPath.split('#')[1];
      if (hash) {
        const targetElement = document.getElementById(hash);
        if (targetElement) {
          targetElement.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      }
    };

    // Scroll to anchor on initial load
    scrollToAnchor();

    // Listen for hash changes
    const handleRouteChange = (): void => {
      scrollToAnchor();
    };

    router.events.on('hashChangeComplete', handleRouteChange);

    return () => {
      router.events.off('hashChangeComplete', handleRouteChange);
    };
  }, [router]);

  useEffect(() => {
    const updateDynamicHeight = (): void => {
      const headerElement = document.querySelector('header')
      const footerElement = footerRef.current
      const headerHeight = headerElement?.clientHeight || 0
      const viewportHeight = window.innerHeight

      let availableHeight = viewportHeight - headerHeight - 16 // Add some padding

      if (footerElement) {
        const footerRect = footerElement.getBoundingClientRect()

        if (footerRect.top < viewportHeight) {
          // Footer is partially visible, reduce available height
          availableHeight = footerRect.top - headerHeight - 16
        }
      }

      setDynamicHeight(availableHeight > 0 ? availableHeight : 0)
    }

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (entry.isIntersecting) {
          updateDynamicHeight()
        }
      },
      { root: null, threshold: 0 }
    )

    const footerElement = document.querySelector('footer')
    if (footerElement) {
      footerRef.current = footerElement
      observer.observe(footerElement)
    }

    // Update height on mount and on window resize
    updateDynamicHeight()
    window.addEventListener('resize', updateDynamicHeight)
    window.addEventListener('scroll', updateDynamicHeight)

    return () => {
      window.removeEventListener('resize', updateDynamicHeight)
      window.removeEventListener('scroll', updateDynamicHeight)
      observer.disconnect()
    }
  }, [])

  return (
    <>
      <div>{headerSectionMobile}</div>
      <USBGrid
        gridGap={defaultGridOptions.gridGap}
        alignItems={defaultGridOptions.alignItems}
        columnCount={defaultGridOptions.columnCount}
        justifyContent={defaultGridOptions.justifyContent}
        display={defaultGridOptions.display}
        padding={isMobileDevice ? "normal" : "zero"}
        addClasses="leftSideGrid"
      >
        {/* Left Side Nav Menu */}
        <USBColumn
          layoutOpts={threeColsOption}
          addClasses={styles.leftSideColumn}
        >
          <div 
            ref={navWrapperRef} 
            className={styles.navWrapper}
            style={{
              width: `${parentWidth}px`,
              top: navWrapperStyles.top,
              bottom: navWrapperStyles.bottom,
              height: `${dynamicHeight}px`,
              overflowY: 'auto',
            }}
            >

            { process.env.SITE_BRAND !== 'usbank' ? (
              <p className={sideNavGroupStyle}>{productNameTitle}</p>
            ) : (
              ''
            )}          
            
            <div
              data-testid={'leftSideBarDocuments'}
              className={leftSideNavStyle}
            >
            {/* Render SideNav Menu
              * Need to remove the localVal check once the US Bank side nav is ready for french canada locale.
              * For now, we are only rendering the side nav for en-us locale
              */}
            {/* { featureDocumentationSidenav === 'true' && localeVal == 'en-us' && (segments[0] == 'products' || segments[1] == 'products') ? ( */}

            { featureDocumentationSidenav === 'true' && localeVal == 'en-us' && (!sideNavExclusionPages.includes(segments[0]) || !sideNavExclusionPages.includes(segments[1])) ? (
              <GlobalSideNavMenu globalItems={sideNavLinks} />
            ) : (
              <SideNavMenu items={sideNavLinks} />
            )}
            </div> 
          </div>        


          </USBColumn>
        {/* Middle Side - Page Content Section */}
        <USBColumn
          layoutOpts={tenColsOption}
          addClasses={styles.markdownContent}
        >
          <div className={documentHeader}>
            {process.env.SITE_BRAND === 'elavon' ? (
              <Breadcrumb
                items={breadcrumbItems}
                updateLayoutOpt={true}
              ></Breadcrumb>
            ) : (
              <Breadcrumb
                pageTitleMetadata={pageTitleMetadata}
                removeMenuFlag={true}
                removeMenuIndex={removeIndexValue}
                updateLayoutOpt={true}
                productVersionNumber={true}
              />
            )}
            {showSuccessMessage && (
              <USBNotification
                variant="confirmation"
                id="promote_cta_success"
                iconAssistiveText={{ label: 'Confirmation' }}
                dataTestId="promote_cta_api-success-notification"
                notificationData={[
                  {
                    text: "Your request has been sent and is in review. You'll receive an email within the next business day with further instructions.",
                  },
                ]}
              />
            )}
            {/* TOC Drop down */}
            {tocExists
              ? process.env.FEATURE_SANDBOX_PROJECTS === 'true' && (
                  <USBDropdown
                    forwardedRef={usbDropdownRef}
                    dropdownType="outlined"
                    addClasses={styles.tocDropdownWrapper}
                    labelText={t('onThisPage', {translation, lng: lang})}
                    
                    defaultSelected={selectedDropDownValue}
                    dataTestId="toc-dropdown"
                    items={buildTocMenu(toc)}
                    handleChange={tocFeatureSandboxProductsDropdownCb}
                  ></USBDropdown>
                )
              : ''}
            {/* TOC Drop down */}
            <h1 className={styles.docTitle} id="doctitle-header">{pageTitle}</h1>
            {/* Add Documentation link button  */}
            {process.env.SITE_BRAND !== 'elavon' &&
            segments[1] == 'products' ? (
              <div className={styles.addProjectBtnWrapper}>
                <ProductHeroButtonWrapper
                  apiProductDetails={productDetails}
                  promoteSuccessHandler={promoteSuccessHandler}
                  documentLink={
                    sideNavData ? sideNavData[0]?.path?.split('/')[4] : ''
                  }
                  sideNavData={sideNavData}
                ></ProductHeroButtonWrapper>
                {process.env.FEATURE_SANDBOX_PROJECTS === 'true' && (
                  <div className={styles.productOverviewDropdown}>
                    {displayVersions && (
                      <USBDropdown
                        dropdownType="text"
                        labelText=""
                        listDirection="bottom"
                        items={displayVersions}
                        defaultSelected={
                          localeVal !== 'en-us' ? t('versionNumber', { translation, lng: lang }) + ' ' + router.asPath.split('/')[4] : t('versionNumber', { translation, lng: lang }) + ' ' + router.asPath.split('/')[3]
                        } 
                        dataTestId={'VersionList'}
                        handleChange={handleDropdownChange}
                      ></USBDropdown>
                    )}
                  </div>
                )}
              </div>
            ) : null}
          </div>
          {/* TOC Drop down */}
          {tocExists
            ? process.env.FEATURE_SANDBOX_PROJECTS === 'false' && (
                <>
                  <p className={styles.tocHeadingMobile}>ON THIS PAGE</p>
                  <USBDropdown
                    forwardedRef={usbDropdownRef}
                    dropdownType="outlined"
                    addClasses={styles.tocDropdownWrapper}
                    labelText=""
                    defaultSelected={defaultTocValue}
                    dataTestId="toc-dropdown"
                    items={buildTocMenu(toc)}
                    handleChange={mobileTocDropdownCb}
                  ></USBDropdown>
                </>
              )
            : ''}
          {/* TOC Drop down */}
          <div
            id="markdown-content"
            className={styles.documentPageMDContent + ' markdown-block'}
            tabIndex={-1}
          >
            {/* render main page content */}
          {renderPageContent(pageData, handleExtractToc)}
          </div>
        </USBColumn>
        {/* Right Side - TOC Menu if exists */}
        {tocExists ? (
          <USBColumn
            layoutOpts={threeColsOption}
            addClasses={
              process.env.SITE_BRAND === 'elavon' 
                ? styles.tableOfContentSectionWrapper
                : styles.MDTOCSectionWrapper}
          >
            <div 
              ref={tocWrapperRef}
              style={{
                position: 'fixed',
                height: `${dynamicHeight}px`,
                overflowY: 'auto',
                top: navWrapperStyles.top,
                bottom: navWrapperStyles.bottom,
                paddingRight: '2rem',
              }}
            >

            { (pageData.genericSection || pageData.documentationSectionsCFM) && (
               <TableOfContent
                items={toc}
                hashValFromUrl={hashValFromUrl}
                tocTitle={t('onThisPage', {translation, lng: lang})}
                onItemClick={handleClick}
                activeAnchor={activeAnchorId}
                maxDepth={2}
                tocTopElement={pageTitle}
               />
              )}
    
            </div>
          </USBColumn>
        ) : (
          ''
        )}
      </USBGrid>
    </>
  )
}

export function tocFeatureSandboxProductsDropdownCb(e: any, selectedItem: any) {
  let selectedTocTitle = selectedItem.value.replace(/\s/g, '-').toLowerCase()
  selectedTocTitle = selectedTocTitle + '_toc'
  handleClick(e, selectedTocTitle)

  return true
}

export function mobileTocDropdownCb(e: any, selectedItem: any) {
  let selectedTocTitle = selectedItem.value.replace(/\s/g, '-').toLowerCase()
  selectedTocTitle = selectedTocTitle + '_toc'
  handleClick(e, selectedTocTitle)

  return true
}

export function listenToKeyUp(event: KeyboardEvent) {
  if (event.key === 'Tab') {
    if (document.activeElement?.tagName === 'BODY') {
      const focusableElements =
        'button, [href], input, select, textarea, [tabindex]:not([tabindex="-1"])'
      const markdownContent: any =
        document.querySelector<HTMLElement>('#markdown-content')
      const focusableContent =
        markdownContent.querySelectorAll(focusableElements)
      const offset = 0

      for (let index = 0; index < focusableContent.length; index++) {
        const element = focusableContent[index]
        const top = element.getBoundingClientRect().top
        const isVisible =
          top + offset >= 0 && top - offset <= window.innerHeight

        if (isVisible) {
          focusableContent[index].focus()
          return
        }
      }
    }
  }

  return true
}

export default ThreeColLayout